import "./index.scss";

import React from "react";
import MDatePicker from "react-datepicker";
import MaskedInput from "react-text-mask";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DateInput from "Components/common/Functions/DatePicker/DateInput/DateInput";
import moment from "moment";
import UTCDatePicker from "../UTCDatePicker/UTCDatePicker";
import { cn } from "@/src/util/ui";

class Default extends React.Component {
    constructor(props) {
        super(props);

        this.inputRef = React.createRef();
        this.pickerInputRef = React.createRef();

        this.state = {
            anchorEl: null
        }
    }

    render() {
        const open = Boolean(this.state.anchorEl);

        const onOpen = () => {
            this.setState({
                ...this.state,
                anchorEl: this.pickerInputRef.current
            })
        }

        const handleClose = () => {
            this.setState({
                ...this.state,
                anchorEl: null
            });
        }
        
        const onChange = date => {
            if(this.props.onChange) {
                this.props.onChange(date);
            }
        }

        const onBlur = e => {
            if(e) {
                onChange(e);
            } else {
                onChange(null);
            }
        }

        const handleInputChange = (date) => {
            onChange(date);
        }
       
        const isToday =this.props.selected?this.props.selected.isSame(new Date(), "day"):false
        return (
            <div class={cn('default-picker-container', this.props.disabled && "disabled tw-cursor-not-allowed")}>
                <div class="picker-input" ref={this.pickerInputRef} onClick={onOpen}>
                    {this.props.enableToday && this.state.anchorEl===null && isToday?
                    <div style={{ padding: "4px 5px 4px 30px"}}> Today</div>:
                    <DateInput 
                    value={this.props.selected} 
                    onBlur={onBlur} 
                    onChange={handleInputChange}
                    dateFormat={this.props.dateFormat}
                    class={this.props.class}
                    disabled={this.props.disabled}
                />
                }
                                          
                    <a>
                        <i class={cn('material-icons', this.props.disabled ? '!tw-text-cfo-grey-400': '!tw-text-cfo-black')}>calendar_today</i>
                    </a>
                </div>
                <Popper open={open} anchorEl={this.state.anchorEl} placement="bottom-start" class={`defaultDatePicker ${this.props.popperClass}`} style={{zIndex: 1053}}>
                    <ClickAwayListener onClickAway={handleClose}>
                        <div>
                            <UTCDatePicker
                                dateFormat="DD-MMM YYYY"
                                placeholderText="MM/DD/YYYY"
                                useWeekdaysShort={true}
                                name={this.props.name}
                                onChange={onChange}
                                class={this.props.classes}
                                ref={this.props.ref}
                                required={this.props.required}
                                disabled={this.props.disabled}
                                selected={this.props.selected}
                                renderDayContents={this.props.renderDays}
                                inline
                                {...this.props.otherProps}
                            />
                        </div>
                    </ClickAwayListener>
                </Popper>
            </div>
        );
    }
}

export default Default;